var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Black"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.08048 0.498576C4.11693 0.831401 1.5641 2.83189 0.501892 5.65027C-0.167297 7.42416 -0.167297 9.47067 0.501892 11.2446C1.48266 13.854 3.7664 15.7873 6.47857 16.3042C7.93025 16.5804 9.4492 16.4564 10.7982 15.9466C12.9651 15.1322 14.6859 13.4115 15.5002 11.2446C16.1694 9.47067 16.1694 7.42416 15.5002 5.65027C14.6859 3.48337 12.9651 1.7626 10.7982 0.948243C9.64394 0.512739 8.35159 0.356949 7.08048 0.498576ZM8.86853 6.94262C10.7699 8.04023 11.1169 8.25268 11.1523 8.34119C11.2514 8.58196 11.301 8.54655 8.86853 9.9522C7.63283 10.6639 6.59895 11.2446 6.57062 11.2446C6.47149 11.2446 6.34402 11.1667 6.30507 11.0781C6.24842 10.9578 6.24842 5.93707 6.30507 5.81314C6.34756 5.72463 6.45378 5.65735 6.56 5.65381C6.59541 5.65027 7.63283 6.23094 8.86853 6.94262Z",
    fill: "#FF9500"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVideo);
export default __webpack_public_path__ + "static/media/ic_video.2930ef81af938cdd5d30fbb1803ac5d1.svg";
export { ForwardRef as ReactComponent };